export default {
  header: {
    home: '首页',
    translateName: '翻译',
    customName: '定制',
    multilingualName: '多语言',
    knowledgeBase: '知识',
    login: '登录',
    signup: '注册',
    siteName: 'ChineseName.us',
    aboutUs: '关于'
  },
  footer: {
    aboutUs: '关于我们',
    contact: '联系我们',
    privacy: '隐私政策',
    terms: '服务条款',
    copyright: '© 2023 ChineseName.us. 保留所有权利。',
    friendlyLinks: '友情链接'
  },
  home: {
    hero: {
      title: '专业中文起名服务',
      subtitle: '以传统文化为基础，融合现代智能技术的中文名字定制平台',
      cta: '立即翻译我的名字'
    },
    features: {
      title: '语言工具服务',
      nameToPinyin: {
        title: '姓名转拼音',
        description: '将中文姓名转换为准确的拼音，附带声调标记和发音指导'
      },
      pinyinToName: {
        title: '拼音查找汉字',
        description: '根据拼音查找适合的汉字，帮助您选择理想的中文名字'
      },
      characterStrokes: {
        title: '汉字笔画书写',
        description: '查看汉字的笔画书写顺序与拼音读法，学习正确的汉字书写方法'
      },
      translateName: {
        title: '将您的名字翻译成中文',
        description: '将外国名字翻译成发音相似的中文名字，提供多种翻译选项和详细含义解释'
      },
      customName: {
        title: '定制中文名字',
        description: '根据您的偏好、个人特质和文化背景定制专属中文名字'
      },
      namingService: {
        title: '个性化起名服务',
        custom: {
          title: '定制中文名字',
          description: '根据您的偏好、个人特质和文化背景定制专属中文名字'
        },
        zodiac: {
          title: '生肖计算器',
          description: '计算您的中国生肖属相并了解其特质和命名建议'
        },
        constellation: {
          title: '星座分析',
          description: '根据您的公历生日分析星座特质，提供详细的星座解读和命名建议'
        },
        numerology: {
          title: '名字数字命理计算器',
          description: '通过数字揭示您名字中隐藏的含义，了解您的性格特质和命运'
        }
      },
      multilingualName: {
        title: '多语言名字翻译',
        description: '支持多种语言的名字翻译，包括英语、法语、德语、西班牙语等'
      },
      knowledge: {
        title: '中文名知识库',
        description: '了解中国起名传统、常用字义、发音规则和文化背景知识'
      },
      nameAnalysis: {
        title: '姓名分析',
        description: '分析您中文名的音律、字义、五行属性和整体搭配'
      }
    },
    categories: {
      translation: '名字翻译服务',
      namingService: '个性化起名服务',
      pinyinTools: '拼音转换工具',
      knowledge: '中文名知识资源'
    },
    about: {
      title: '关于我们',
      description: '我们是一支专注于中文名字服务的专业团队，结合语言学、文化研究和现代技术，为全球用户提供高质量的中文名字解决方案。',
      expertise: {
        title: '专业团队',
        description: '我们的团队由语言学专家、文化顾问和技术开发人员组成，拥有多年研究中文命名传统的经验。'
      },
      quality: {
        title: '高质量服务',
        description: '我们致力于提供准确、专业、富有文化内涵的中文名字解决方案，帮助每位用户获得完美的中文名字。'
      },
      global: {
        title: '全球服务',
        description: '我们服务来自世界各地的用户，提供个性化的中文名字创建和翻译服务，尊重不同文化背景和个人需求。'
      },
      team: {
        title: '我们的团队',
        description: '我们是一群热爱语言和文化的人，对中文语言和命名传统有深入研究，并通过技术手段将这些知识应用于我们的服务平台。'
      },
      contact: {
        title: '联系我们',
        description: '如果您有任何问题、建议或合作意向，欢迎随时联系我们。我们期待为您提供帮助！',
        button: '给我们发邮件'
      }
    }
  },
  translate: {
    title: '将您的名字翻译成中文',
    firstName: '名',
    lastName: '姓',
    fullName: '您的全名',
    fullNamePlaceholder: '请输入您的全名...',
    gender: '性别',
    male: '男',
    female: '女',
    other: '其他',
    translateButton: '翻译',
    errors: {
      fullNameRequired: '请输入您的全名',
      firstNameRequired: '请输入您的名'
    },
    results: {
      title: '翻译结果',
      characters: '汉字',
      pinyin: '拼音',
      meaning: '含义',
      pronunciation: '发音',
      cultural: '文化背景',
      alternatives: '备选方案'
    }
  },
  custom: {
    title: '创建您的定制中文名字',
    preferences: '偏好',
    meaning: '期望含义',
    sound: '音韵偏好',
    characteristics: '个人特征',
    birthdate: '出生日期时间',
    generateButton: '生成名字',
    showMore: '显示更多选项',
    showLess: '收起选项',
    playPronunciation: '播放发音',
    results: {
      title: '定制名字建议',
      explanation: '名字解释',
      cultural: '文化背景',
      save: '保存此名字',
      birthInfo: '生辰八字信息',
      nameAnalysis: '姓名分析'
    },
    nameAnalysis: {
      strokes: '笔画',
      fiveElements: '五行',
      soundMeaning: '音义',
      compatibility: '八字配合度',
      score: '评分'
    },
    birthInfo: {
      solarDate: '公历',
      lunarDate: '农历',
      zodiac: '生肖',
      eightChar: '八字',
      fiveElements: '五行',
      naYin: '纳音',
      year: '年柱',
      month: '月柱',
      day: '日柱',
      hour: '时柱'
    }
  },
  multilingual: {
    title: '多语言名字翻译',
    sourceLang: '源语言',
    targetLang: '目标语言',
    name: '您的名字',
    translateButton: '翻译',
    results: {
      title: '翻译结果',
      original: '原名',
      translated: '翻译',
      pronunciation: '发音',
      alternatives: '备选方案'
    }
  },
  knowledge: {
    title: '中文名字知识库',
    categories: {
      surnames: '中国姓氏',
      naming: '命名传统',
      historical: '历史人物名字',
      regional: '区域差异',
      taboos: '命名禁忌'
    },
    soundFormTaboos: {
      title: '字音字形避讳',
      subtitle: '避免与长辈、名人同名或与不吉利含义谐音的字',
      sections: {
        intro: '在中国传统文化中，取名是一件极为重要的事情，而名字的字音和字形避讳则是取名过程中不可忽视的关键环节。',
        soundTaboos: '字音避讳',
        formTaboos: '字形避讳',
        combinationTaboos: '字音字形组合避讳',
        modernConsiderations: '现代社会的避讳考量',
        practicalGuidelines: '实用命名指南'
      }
    },
    modernTraditional: {
      title: '现代与传统的结合',
      subtitle: '在名字选择中平衡传统文化元素与现代审美',
      sections: {
        historicalEvolution: '命名理念的历史演变',
        balancePrinciples: '平衡传统与现代的命名原则',
        practicalExamples: '现代传统结合的实践案例',
        practicalApproaches: '实用的结合策略',
        futureTrends: '未来趋势与展望'
      }
    },
    professionalConsiderations: {
      title: '职业与社会角色考量',
      subtitle: '基于职业抱负和现代社会角色的名字选择',
      sections: {
        nameInfluence: '名字对职业发展的潜在影响',
        differentFields: '不同职业领域的命名考量',
        genderNeutrality: '性别中立与职业发展',
        internationalContext: '国际职场背景下的命名策略',
        digitalAge: '数字时代的职业命名新考量'
      }
    }
  },
  chineseSurnames: {
    title: '中国姓氏',
    intro: {
      title: '中国姓氏的起源与演变',
      content: '中国的姓氏文化源远流长，是世界上最古老、最丰富的姓氏体系之一。从夏商周三代到如今，中国姓氏经历了数千年的发展演变，形成了独具特色的姓氏文化体系。',
      imageCaption: '中国古代姓氏文化示意图'
    },
    distinction: {
      title: '姓氏与氏的区别',
      content: '在中国古代，"姓"与"氏"原本是两个不同的概念：',
      surname: '姓：最初源于母系社会，表示血缘关系，以女性为本。古代"女"字旁的字多为姓，如姬、姜、姚等。',
      clan: '氏：起源于父系社会，代表家族、部落或封地，与社会地位和职业相关。',
      merge: '周代以后，姓氏逐渐合流，形成今天我们所熟知的"姓氏"概念。'
    },
    origins: {
      title: '中国姓氏的主要来源',
      intro: '中国姓氏的形成途径多种多样，主要包括以下几种来源：',
      totem: {
        title: '1. 源于图腾崇拜',
        content: '远古时期，各部落以自己崇拜的动植物或自然物作为图腾，这些图腾后来演变为姓氏。例如：',
        examples: [
          '熊氏（熊图腾）',
          '马氏（马图腾）',
          '龙氏（龙图腾）'
        ]
      },
      ancestor: {
        title: '2. 源于祖先名号',
        content: '以祖先的名字或号作为后代的姓氏。例如：',
        examples: [
          '姬姓（黄帝名姬轩辕，其后代以姬为姓）',
          '赵、钱、孙、李等源于先祖名字'
        ]
      },
      territory: {
        title: '3. 源于封地或国名',
        content: '以封地或所属国家的名称作为姓氏。例如：',
        examples: [
          '齐姓（源于齐国）',
          '鲁姓（源于鲁国）',
          '卫姓（源于卫国）'
        ]
      },
      official: {
        title: '4. 源于官职',
        content: '以祖先担任的官职为姓氏。例如：',
        examples: [
          '司马（掌管军事的官职）',
          '司徒（掌管民政的官职）',
          '司空（掌管工程的官职）'
        ]
      },
      migration: {
        title: '5. 源于迁徙改姓',
        content: '由于战乱、政治因素或其他原因而改姓。例如：',
        examples: [
          '李唐皇室后裔避难时改为赵、郭等姓',
          '汉末三国时期，曹操部下有人为避战乱改姓'
        ]
      },
      minority: {
        title: '6. 少数民族汉化',
        content: '少数民族融入汉族后采用的汉姓。例如：',
        examples: [
          '完颜氏改为王氏',
          '爱新觉罗氏改为金、金啸等'
        ]
      }
    },
    distribution: {
      title: '中国姓氏的分布与特点',
      intro: '中国姓氏呈现出"大姓千万家，小姓寥寥无几"的特点。据统计，当代中国大约有3000多个姓氏，其中使用人数最多的姓氏是：',
      topSurnames: [
        { rank: 1, name: '李', percentage: '约占总人口的7.9%' },
        { rank: 2, name: '王', percentage: '约占总人口的7.4%' },
        { rank: 3, name: '张', percentage: '约占总人口的7.1%' },
        { rank: 4, name: '刘', percentage: '约占总人口的5.4%' },
        { rank: 5, name: '陈', percentage: '约占总人口的4.5%' }
      ],
      conclusion: '前100个大姓覆盖了中国约85%的人口，这种分布特点与中国历史上的人口迁徙、政治变革等因素密切相关。'
    },
    significance: {
      title: '姓氏文化的历史意义',
      intro: '姓氏不仅是家族的标识，也承载着丰富的历史文化内涵：',
      points: [
        '血缘纽带：姓氏是血缘关系的象征，维系着家族的凝聚力',
        '历史见证：不同姓氏的兴衰反映了中国社会的历史变迁',
        '文化传承：姓氏家谱记录了家族历史和文化传统',
        '地域特色：某些姓氏在特定地区高度集中，形成了独特的区域文化'
      ]
    },
    modern: {
      title: '现代社会中的姓氏文化',
      intro: '在当代社会，姓氏文化依然发挥着重要作用：',
      points: [
        '家族观念的传承与家谱研究的兴起',
        '寻根问祖活动的普及，增强文化认同感',
        '姓氏作为个人身份的重要组成部分',
        '海外华人通过姓氏维系与祖国的联系'
      ],
      conclusion: '随着社会的发展，姓氏文化也在不断创新和发展，姓氏研究已成为文化研究和历史研究的重要分支。'
    }
  },
  nameToPinyin: {
    title: '中文姓名转拼音',
    chineseName: '中文姓名',
    convertButton: '转换为拼音',
    playFullName: '播放完整姓名发音',
    downloadMP3: '下载MP3发音文件',
    results: {
      title: '拼音结果',
      standard: '标准拼音',
      withTones: '带声调拼音',
      pronunciation: '发音指南'
    }
  },
  pinyinToName: {
    title: '拼音转中文姓名',
    pinyin: '拼音输入',
    tone: '声调',
    gender: '性别',
    convertButton: '查找汉字',
    results: {
      title: '汉字选项',
      character: '汉字',
      meaning: '含义',
      popularity: '流行度'
    }
  },
  zodiac: {
    title: '生肖计算器',
    birthYear: '出生年份',
    calculateButton: '计算生肖',
    results: {
      title: '您的生肖结果',
      personality: '性格特点',
      compatibility: '相合与相冲',
      luckyNumbers: '幸运数字',
      luckyColors: '幸运颜色',
      element: '五行属性',
      year: '年份'
    }
  },
  zodiacNaming: {
    title: '生肖起名',
    birthYear: '出生年份',
    surname: '姓氏',
    gender: '性别',
    male: '男',
    female: '女',
    generateButton: '生成名字建议',
    results: {
      title: '生肖起名建议',
      year: '年',
      element: '属性',
      nameRecommendations: '推荐名字',
      namingTips: '起名小贴士'
    }
  },
  constellation: {
    title: '星座分析',
    subtitle: '探索您的星座特质与命名灵感',
    birthDate: '出生日期',
    calculate: '计算星座',
    results: {
      sign: '星座',
      element: '元素属性',
      traits: '性格特点',
      strengths: '优势',
      weaknesses: '挑战',
      compatibility: '最佳配对',
      namingTips: '命名建议',
      famousPersons: '名人代表',
      dateRange: '日期范围',
      guardianStar: '守护星',
      symbolMeaning: '符号象征',
      luckyColor: '幸运颜色',
      luckyNumber: '幸运数字',
      luckyStone: '幸运石',
      luckyDay: '幸运日',
      flower: '星座花',
      flowerMeaning: '花语',
      flowerAndMeaning: '星座花与花语',
      mythOrigin: '神话由来'
    },
    signs: {
      aries: '白羊座',
      taurus: '金牛座',
      gemini: '双子座',
      cancer: '巨蟹座',
      leo: '狮子座',
      virgo: '处女座',
      libra: '天秤座',
      scorpio: '天蝎座',
      sagittarius: '射手座',
      capricorn: '摩羯座',
      aquarius: '水瓶座',
      pisces: '双鱼座'
    },
    elements: {
      fire: '火象',
      earth: '土象',
      air: '风象',
      water: '水象'
    }
  },
  nameAnalysis: {
    title: '中文姓名分析',
    name: '中文姓名',
    analyzeButton: '分析',
    results: {
      title: '姓名分析结果',
      strokes: '笔画数',
      fiveElements: '五行属性',
      soundMeaning: '音义分析',
      surname: '姓氏分析',
      givenName: '名字分析',
      compatibility: '与生日的匹配度'
    }
  },
  common: {
    loading: '加载中',
    copy: '复制',
    share: '分享',
    copied: '已复制到剪贴板',
    generatingNames: '正在为您生成个性化中文名字，请稍候...',
    translatingName: '正在翻译您的名字，请稍候...',
    processing: '处理中',
    success: '成功',
    error: '错误',
    retry: '重试',
    cancel: '取消',
    confirm: '确认',
    required: '必填字段',
    optional: '可选',
    search: '前往',
    noResults: '未找到结果'
  },
  characterStrokes: {
    title: '汉字笔画书写顺序',
    subtitle: '查看汉字的笔画书写顺序与拼音读法，学习正确的汉字书写方法',
    inputTitle: '输入汉字查询笔画',
    inputPlaceholder: '输入一个汉字',
    inputHint: '请输入一个中文汉字，例如：爱、德、福等',
    popularCharacters: '常用汉字',
    loading: '正在查询汉字笔画信息...',
    pinyin: '拼音',
    strokeCount: '笔画数',
    radical: '部首',
    meaning: '释义',
    strokeOrder: '笔画书写顺序',
    demoAnimation: '演示动画',
    strokeDetails: '笔画详解',
    basicStrokes: '基本笔画',
    strokeSequence: '此字笔顺',
    noSequenceData: '暂无详细笔顺数据',
    relatedCharacters: '相关汉字',
    noRelatedData: '暂无相关汉字数据',
    errorTitle: '查询出错',
    noData: '暂无数据'
  },
  numerology: {
    title: '名字数字命理计算器',
    fullName: '全名',
    fullNamePlaceholder: '请输入您的全名',
    selectSystem: '命理系统',
    pythagorean: '毕达哥拉斯',
    chaldean: '迦勒底',
    calculateButton: '计算数字命理',
    guideTitle: '如何使用名字数字命理计算器',
    results: {
      title: '您的数字命理分析',
      expressionNumber: '表达数',
      soulUrgeNumber: '灵魂渴望数',
      personalityNumber: '个性数',
      meaningTitle: '数字含义',
      traits: '关键特质',
      luckyColors: '幸运色彩',
      luckyGems: '幸运宝石',
      coreNumbers: '您的核心数字',
      calculationDetails: '计算详情',
      expressionCalculation: '表达数计算',
      soulUrgeCalculation: '灵魂渴望数计算',
      personalityCalculation: '个性数计算',
      sum: '总和',
      reduction: '化简'
    },
    guide: {
      title: '理解名字数字命理学',
      intro: '名字数字命理学是一种古老的实践，通过给名字中的字母赋予数值来揭示关于您个性、优势和人生路径的洞见。数字命理学在各种文化中已有几千年的历史，帮助人们更好地理解自己和人际关系。',
      systems: {
        title: '数字命理系统',
        content: '全球使用的数字命理系统主要有两种，每种系统对字母赋值和解读结果的方法都有所不同：',
        pythagoreanDesc: '最广泛使用的系统，由希腊数学家毕达哥拉斯发展而来。它按照顺序模式将数字1-9分配给字母，被认为更现代、更易于理解。',
        chaldeanDesc: '源自巴比伦的古老系统，基于字母的振动价值将数字1-8分配给字母。传统数字命理学家认为它更准确但也更复杂。'
      },
      coreNumbers: {
        title: '数字命理学中的核心数字',
        content: '您的名字包含几个关键的数值，揭示了您个性和生活的不同方面：',
        expressionDesc: '代表您的整体潜能、自然能力和人生目的。通过计算全名中所有字母的数值得出。',
        soulUrgeDesc: '揭示您内在的愿望、动机和内心真正的渴望。通过计算名字中所有元音的数值得出。',
        personalityDesc: '展示他人如何看待您以及您如何向世界呈现自己。通过计算名字中所有辅音的数值得出。'
      },
      faq: {
        title: '常见问题',
        q1: '数字命理学有多准确？',
        a1: '数字命理学被视为一种解释性艺术而非精确科学。许多人发现他们的数字命理解读提供了对其个性和人生路径的有价值洞见，而其他人则将其视为自我反思的有趣工具。准确性常常取决于个人信念以及信息与您的共鸣程度。',
        q2: '毕达哥拉斯系统和迦勒底系统哪个更好？',
        a2: '没有哪个系统明确比另一个"更好"。毕达哥拉斯系统在西方世界更为常用，通常更容易理解。一些传统数字命理学家认为迦勒底系统更准确，因为它基于振动频率而非顺序排列。我们建议您尝试两种系统，看看哪一种与您更有共鸣。',
        q3: '计算时应该使用出生名还是现用名？',
        a3: '为了进行最全面的分析，如果您的出生名和现用名不同，您可以计算两者的数字命理。您的出生名揭示了天生的品质和原始人生路径，而现用名则反映了您不断发展的身份和当前投射的能量。'
      }
    }
  }
}